const state={
  note:{
    sms_num:null,//测试
    SMScontent:null,//群发短信内容
    memberScreening:null// 会员筛选条件
  }
}
export default state
